<template lang="pug">
  .contenedor-datos
    .modal.is-active(v-if="mostrarModalAdjuntar",  :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
      .modal-background(@click="closeModalAdjuntar")
      transition(name='fade-quick')
        .overlay-class(
        )
          upload-image(
            name="adjuntar_foto_perfil",
            folder="fotoPerfil",
            :onlyImg="true",
            @save="guardarAdjunto"
            @close="closeModalAdjuntar"
          )
            span(slot="title") Adjuntar Foto de Perfil
            span(slot="explanation") Adjunta la imagen que deseas usar como foto de perfil
            span(slot="dropzoneDescription") Arrastra la imagen que desees cargar o dale click al recuadro para buscar en tus archivos
            i(slot="topIcon").fa.fa-file-image-o
    .modal.is-active(v-if="mostrarConfirmacionEliminar",  :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
      .modal-background(@click="mostrarConfirmacionEliminar=false")
      transition(
        name='fade',
        tag="div",
        )
        confirmar-accion-overlay(
          @close="mostrarConfirmacionEliminar = false"
          @do="eliminarFotoPerfil"
          ref="confirmarEliminar"
        )
          span(slot="title") ¿Desea eliminar su foto de perfil?
          span(slot="primaryAction")
            template(v-if="isSending")
              | Eliminando...
            template(v-else)
              | Eliminar
    .title
      span.little Foto de Perfil
      span.icon.close(@click="$emit('close')")
        i.fa.fa-close
    template(v-if="isLoading")
      loading
    template(v-else)
      .img(v-if="pathFoto")
        img(:src="pathFoto", alt="foto-usuario")
      .contenedor-acciones
        button.button.is-primary(type="button" @click="openModalAdjuntar" v-if="!pathFoto")
          span.icon.is-small
            i.fa.fa-upload.is-small
          span Adjuntar
        //- sino borrar foto con icono de tacho
        button.button.is-small.is-danger(@click="mostrarConfirmacionEliminar=true", v-else)
          span.icon.is-small
            i.fa.fa-trash
          span Eliminar foto

</template>

<script>
import { apiGet, notify, apiPost, apiDelete } from '../util/general'
import UploadImageComponent from './Component_Upload_Image'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'

export default {
  name: 'datos_personales_foto_perfil_component',
  components: {
    'upload-image': UploadImageComponent,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  data () {
    return {
      empleado: {},
      empleadoPersonal: {},
      isLoading: true,
      mostrarModalAdjuntar: false,
      codigoEmpleado: +localStorage.getItem('codigo'),
      mostrarConfirmacionEliminar:false
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        codigo : vm.codigoEmpleado
      }
      apiGet(vm, '/personal/fotoPerfil', obj, function (data) {
        vm.pathFoto = data.foto
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardarFotoPerfil () {
      var vm = this
      var obj = {
        codigo : vm.codigoEmpleado,
        pathFoto : vm.pathFoto
      }
      apiPost(vm, '/personal/fotoPerfil', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        window.location.reload()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    guardarAdjunto (fileSubido) {
      var vm = this
      vm.closeModalAdjuntar()
      if (fileSubido) vm.pathFoto = fileSubido.file.ruta
      else vm.pathFoto = ''
      vm.guardarFotoPerfil()
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    eliminarFotoPerfil () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        codigo : vm.codigoEmpleado
      }
      apiDelete(vm, '/personal/fotoPerfil', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        window.location.reload()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .contenedor-datos
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
        i
          position absolute
          top 5px
          right: 5px
      .little
        font-size 14px
    .img
      padding-bottom: 10px
      img
        max-width 100%
        width auto
        height 130px
        border-radius 5px

  .conjunto-datos
    display flex
    text-align left
    flex-direction column
    .danger
      color red
    .body
      background-color #f8f9fa
      border-radius 5px
      padding 10px
      margin-bottom 10px

  DatosConjunto
    .body
      .title
        font-size: 1.1rem
</style>



// WEBPACK FOOTER //
// Component_Datos_Personales_Foto_Perfil.vue?7ebf5730